import { render, staticRenderFns } from "./IRadio.vue?vue&type=template&id=439b1498"
import script from "./IRadio.vue?vue&type=script&lang=js"
export * from "./IRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports